import { Component, ChangeDetectionStrategy, ViewEncapsulation, Output, EventEmitter, Input, ElementRef, AfterViewInit } from '@angular/core';
import * as Opentip from '../../../scripts/tooltip.js';

@Component({
    selector: 'tr-player-button',
    template: `<button [ngClass]="{'active': active }" [ngClass]="[tooltipType]" class='tr-player-button' (click)="onButtonClick.emit($event)" >
        <ng-content></ng-content>
    </button>`,
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export class TrPlayerButtonComponent implements AfterViewInit {

    @Input() public tooltipPlayer: string;
    @Input() public tooltipType: 'default' | 'top-left' | 'top-right' = 'default';
    @Input() public active: boolean;
    @Output() public onButtonClick: EventEmitter<Event> = new EventEmitter();
    public title: string;

    constructor(
        private elementReference: ElementRef,
    ) {}

    public ngAfterViewInit() {
        // new Opentip(this.elementReference.nativeElement, {tipJoint: "bottom", className: 'tr-player-button-tooltip', fixed: true  });
    }
}
